module.exports = __webpack_public_path__ + "static/media/tt_norms_light.87d530b7.otf";